import MemberAliPay from '@/views/qrcode/MemberAliPay.vue'

export default [
  {
    path: '/qrcode-member-ali-pay/:qrcode_id/:token',
    name: '支付宝支付',
    component: MemberAliPay,
  },
]
